import { ModalContextProvider } from 'modules/experiments/contexts';
import { ExperimentsMonitorPage } from './ExperimentsMonitorPage';
import 'modules/experiments/ducks/sagas';

export const ExperimentsMonitorContext = () => {
  return (
    <ModalContextProvider>
      <ExperimentsMonitorPage />
    </ModalContextProvider>
  );
};
